const modules = Object.freeze({
    'Accounting': { value: "Accounting", id: '70b9492f-1f70-46a7-b834-c60b8851fc48' },
    'Sales': { value: "Sales", id: '371b441b-67c7-40d3-ab0d-0e42c7826023' },
    'Purchase': { value: "Purchase", id: '2c298384-f92e-49ce-b64f-1c3279875adc' },
    'Reporting': { value: "Reporting", id: '179c8f40-a86c-471e-ac87-fa7297d34ed6' },
    'DayStart': { value: "DayStart", id: '180c4fae-9dc3-4c94-9598-d4301791d3d8' },
    'SettingsAndPermission': { value: "Settings And Permission", id: 'c537be91-4d82-4dc7-89f2-c4ddf449c8a2' },
    'SetupsAndConfiguration': { value: "Setups And Configuration", id: '39a0fb79-8d92-4e4f-b03c-164a5ab11145' },
    'ManufacturingAndProduction': { value: "Manufacturing And Production", id: 'd7567272-6f83-4989-8754-f7421f68b02c' },
    'HrAndPayRoll': { value: "HR And PayRoll", id: '88471f6c-9887-42ee-963b-9b4d83dc5cd1' },
    'Expenses': { value: "Expenses", id: '050953d3-4c73-4c31-b008-0d84cb72d560' },
    'ProductAndInventoryManagement': { value: "Product And Inventory Management", id: 'e33036b6-1c2e-4669-ba88-3822f8fbdc8b' },
    'WareHouseManagement': { value: "WareHouse Management", id: '80a7155b-68d9-451a-ad73-47fc2896e28e' },
    'Logistic': { value: "Logistic", id: '082ca413-d569-4b71-a6e9-7119a63c64c5' },
    'InquiryManagement': { value: "Inquiry Management", id: '970e1459-e5ef-4fc2-9bd0-4ba8280627bc' },
    //'Other': { value: "Other", id: '3a0a2ddf-0773-4746-913d-0ef1397cc14f' },
});

export default modules;
